import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "hitch"
const HitchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.5 3.75H21.419C20.827 3.75 20.259 3.984 19.839 4.4L16.766 7.431H22.5V8.932H12C11.379 8.932 10.875 9.435 10.875 10.057V12.182H12.313C12.726 12.182 13.063 12.518 13.063 12.932S12.727 13.682 12.313 13.682H10.875V16.5H14.532C15.132 14.964 16.626 13.875 18.375 13.875S21.618 14.964 22.218 16.5H22.5V18C22.5 20.278 20.653 22.125 18.375 22.125S14.25 20.278 14.25 18H10.935C10.75 18.425 10.486 18.817 10.151 19.151 9.448 19.855 8.495 20.25 7.5 20.25S5.552 19.855 4.849 19.151C4.145 18.448 3.75 17.495 3.75 16.5H5.25C5.25 17.097 5.487 17.669 5.91 18.09 6.33 18.514 6.902 18.75 7.5 18.75S8.669 18.513 9.09 18.09Q9.253 17.93 9.376 17.743V10.057C9.375 8.607 10.55 7.432 12 7.432H14.63L18.784 3.33C19.486 2.638 20.433 2.25 21.42 2.25H22.5zM18.375 15.375C16.925 15.375 15.75 16.55 15.75 18S16.925 20.625 18.375 20.625 21 19.45 21 18 19.825 15.375 18.375 15.375M4.5 11.625C5.536 11.625 6.375 12.465 6.375 13.5S5.535 15.375 4.5 15.375 2.625 14.535 2.625 13.5 3.465 11.625 4.5 11.625" />
        </svg>
      }
    </span>
  )
}
export default HitchIcon
